import { createRouter, createWebHistory } from 'vue-router'
import HubView from '@/views/HubView.vue'
import DashboardView from '@/views/dashboardView.vue'
import ReservationsView from '@/views/reservationsView.vue'
import PropertiesView from '@/views/ProprietiesView.vue'
import SettingsView from '@/views/SettingsView.vue'
import UserLogin from '@/views/userLogin.vue'
import RegisterView from '@/views/RegisterView.vue'
import AdminView from '@/views/AdminView.vue'

// MILESTONE 2: Finance Views
import MonthEndView from '@/views/MonthEndView.vue'
import XeroSettingsView from '@/views/XeroSettingsView.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: UserLogin
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView
  },
  {
    path: '/',
    name: 'Hub',
    component: HubView,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/reservations',
    name: 'Reservations',
    component: ReservationsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/properties',
    name: 'Properties',
    component: PropertiesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: SettingsView,
    meta: { requiresAuth: true }
  },

  // ========================================
  // MILESTONE 2: FINANCE ROUTES
  // ========================================
  {
    path: '/finance/month-end',
    name: 'MonthEnd',
    component: MonthEndView,
    meta: { requiresAuth: true }
    // Note: Feature flag guard will be added in Milestone 3 when backend supports it
  },
  {
    path: '/finance/xero-settings',
    name: 'XeroSettings',
    component: XeroSettingsView,
    meta: { requiresAuth: true }
    // Note: Feature flag guard will be added in Milestone 4 when Xero integration is implemented
  },

  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  } else {
    if (token && to.name === 'Login') {
      next('/')
    } else {
      next()
    }
  }
})

export default router